import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'ghost';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

export function Button({ variant = 'primary', children, className = '', ...rest }: Props) {
  return (
    <button
      type={rest.type ?? 'button'}
      className={`${styles.base} ${styles[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
